import React, { Component } from 'react';

class BoomPage extends Component {
  // But this will (see first have of sentence below)
  public componentDidMount() {
    throw new Error(`BOOM`);
  }

  public render() {
    const throwError = (cycle: any) => {
      throw new Error(`I crashed on ${cycle}!`);
    };
    return (
      // Note this does not get handled by the Error Boundry
      <div className="f1">💥</div>
    );
  }
}

export default BoomPage;
